module.exports = __webpack_public_path__ + "img/2.11.6d9bdd6d.png";